import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent, SelectProps } from '@mui/material/Select';

export type SelectOneProps = SelectProps & {
  inputLabel: string;
  ariaLabel: string;
  items: string[];
  disabled?: boolean;
  onChange: (event: SelectChangeEvent<unknown>) => void;
  startAdornment: JSX.Element | null;
}
export const SelectOne: React.FC<SelectOneProps> = (props) => {
  const selectOneProps = ['inputLabel', 'items'];
  const filterProps = Object.entries(props).filter((x) => !selectOneProps.includes(x[0]));
  const convertedProps: SelectProps = Object.fromEntries(filterProps);
  return (
    <FormControl focused={false} size={'small'} area-label={props.inputLabel}>
      <InputLabel
      id={props.inputLabel}
        sx={{
          fontSize: '1rem',
        }}
      >
        {props.inputLabel}
      </InputLabel>
      <Select
        {...convertedProps}
        MenuProps={{ disableEnforceFocus: true }}
        variant={'outlined'}
        sx={{
          fontSize: '1rem',
          fontWeight: 400,
          height: 40,
          width: 290,
        }}
        labelId={props.inputLabel}
        label={props.inputLabel}
        aria-label={props.ariaLabel}
        disabled={props.disabled}
      >
        {props.items.map((e, index) => {
          return (
            <MenuItem disableRipple
              sx={{
                '&.Mui-selected': {
                  backgroundColor: 'rgba(202, 202, 252, 0.2)',
                  color: '#3C419A !important',
                },

                '& .MuiMenuItem-root .MuiMenuItem-gutters .Mui-selected .MuiButtonBase-root': {
                  bgcolor: 'none',
                  color: '#3C419A',
                },
                '&:hover': {
                  bgcolor: 'rgba(202, 202, 252, 0.2)',
                  color: '#3C419A !important',
                },
              }}
              key={`menu-Item-${index}`}
              value={index}
            >
              {e}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
